import Vue from 'vue'
import App from './App.vue'

// import axios from '@/axios/http';
// Vue.prototype.$http = axios

Vue.config.productionTip = false

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import router from './router/index.js';

import vuexStore from "@/store/$u.mixin.js"
import store from '@/store/$u.index.js';
Vue.mixin(vuexStore);

import http from '@/axios/http.js'
Vue.prototype.$http = http

Vue.prototype.$imgUrl = process.env.VUE_APP_BASE_API + "/stage-api";
// 拼接图片完整访问地址：自动处理多余斜杠，已带 http(s) 的完整地址原样返回
// 支持三种入参：相对路径(profile/xx.png) / 带 /stage-api 前缀(/stage-api/profile/xx.png) / 完整 URL
Vue.prototype.$img = function (path) {
	if (path === null || path === undefined || path === '') return ''
	const s = String(path)
	// 已经是完整地址（含协议或 // 开头）直接返回
	if (/^(https?:)?\/\//i.test(s)) return s
	// 基础地址：去掉 VUE_APP_BASE_API 末尾斜杠，再补 /stage-api，避免双斜杠
	let base = (process.env.VUE_APP_BASE_API || '').replace(/\/+$/, '') + '/stage-api'
	let p = s.replace(/^\/+/, '')            // 去掉开头斜杠
	p = p.replace(/^stage-api\//, '')        // 若已带 /stage-api 前缀则去掉，避免重复
	return base + '/' + p
}
// import bootstrapcss from '@/assets/bootstrap/bootstrap.min.css';
// import bootstrapjs from '@/assets/bootstrap/bootstrap.bundle.js';

import utils from '@/utils/utils.js';
// Vue.use(utils, App)
Vue.prototype.$utils = utils

// 全局成功提示弹窗（居中动画 + SVG 勾选 + 自动消失）
// 任意页面调用：this.$successToast({ text: '购买成功', sub: '订单已支付', duration: 2300 })
import SuccessToast from '@/components/SuccessToast.vue'
Vue.component('SuccessToast', SuccessToast)
const successToastInstance = new Vue({
    render: h => h(SuccessToast),
}).$mount()
document.body.appendChild(successToastInstance.$el)
Vue.prototype.$successToast = (options) => {
    successToastInstance.$children[0].show(options)
}

// 字典数据组件----------->main.js
// import DictData from '@/components/DictData'
// // 字典组件挂载到Vue上当做插件使用
// DictData.install()

import _ from 'lodash'
Vue.prototype.$_ = _;

export const vm = new Vue({
	render: h => h(App),
	router,
	store,
	// bootstrapcss,
	// bootstrapjs,
}).$mount('#app')

// 引入请求封装，将app参数传递到配置中
// require('@/axios/http.js')(App)
